<template>
  <van-pagination
    v-model="pageIndex"
    :items-per-page="currentCount"
    :total-items="totalCount"
    force-ellipses
    :show-page-size="4"
  >
    <template #prev-text>
      <van-icon name="arrow-left" />
    </template>
    <template #next-text>
      <van-icon name="arrow" />
    </template>
  </van-pagination>
</template>

<script>
export default {
  inheritAttrs: false,
  props: {
    currentPage: {
      type: Number,
      required: true
    },
    currentCount: {
      type: Number,
      required: true
    },
    totalCount: {
      type: Number,
      required: true
    }
  },
  computed: {
    pageIndex: {
      get() {
        return this.currentPage;
      },
      set(val) {
        this.$emit('update:currentPage', val)
      }
    }
  }
}
</script>

<style lang="less" scoped>
  .van-pagination { padding: 0 16px;
    /deep/ &__item { min-width: 32px; height: 36px; }
  }
</style>